var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',_vm._g(_vm._b({attrs:{"border":"left","outlined":"","text":"","color":_vm.alertColor,"type":_vm.type,"dense":_vm.dense}},'v-alert',_vm.$attrs,false),_vm.$listeners),[_c('span',{class:`${_vm.alertColor}--text text--darken-2 ${
      _vm.dense ? 'text-body-2' : 'text-body-1'
    }`},[_vm._t("default")],2),(_vm.message)?_c('v-divider',{staticClass:"my-1"}):_vm._e(),_c('pre',[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }